import { BaseEntity } from '@base-entities';
import { SubRegionTransformer } from '../transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeSubRegionTransformer<E extends BaseEntity = BaseEntity>(
  region: any,
): IBaseTransformerRepository<E> {
  return new SubRegionTransformer<E>(region);
}
